module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col space-y-8 py-2.5 px-3"
  }, [_c('div', {
    staticClass: "px-5 flex flex-col space-y-3",
    attrs: {
      "id": "written-student-reports"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "border border-solid border-blueGray-200 rounded flex flex-col space-y-3",
    attrs: {
      "id": "skills-assessment-container"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "skills-summary-table"
    }
  }, [_c('SkillsSummary')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "border border-solid border-blueGray-200 rounded flex flex-col space-y-3",
    attrs: {
      "id": "participation-summary-container"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "participation-summary-chart"
    }
  }, [_c('ParticipationChart')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 flex flex-col space-y-3",
    attrs: {
      "id": "verbal-student-reports"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "border border-solid border-blueGray-200 rounded flex flex-col space-y-3",
    attrs: {
      "id": "tapin-container"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    attrs: {
      "id": "taps-summary-chart"
    }
  }, [_c('TapsSummary')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "border border-solid border-blueGray-200 rounded flex flex-col space-y-3",
    attrs: {
      "id": "speaking-summary-container"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    attrs: {
      "id": "speaking-summary-chart"
    }
  }, [_c('SpeakingChart')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 flex flex-col space-y-3",
    attrs: {
      "id": "student-refections"
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "border border-solid border-blueGray-200 rounded flex flex-col space-y-3",
    attrs: {
      "id": "reflections-container"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reflection.text),
      expression: "reflection.text"
    }],
    staticClass: "outline-none bg-white py-2.5 px-3.5 rounded",
    class: _vm.hasTeacherPermissionsInCourse || _vm.getProfile.role === 'teacher' ? 'resize-none' : '',
    attrs: {
      "disabled": _vm.hasTeacherPermissionsInCourse || _vm.getProfile.role === 'teacher',
      "placeholder": _vm.hasTeacherPermissionsInCourse ? 'No reflections from this student...' : 'Write your reflections on your progress and contributions.',
      "rows": "11"
    },
    domProps: {
      "value": (_vm.reflection.text)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reflection, "text", $event.target.value)
      }, _vm.onInput]
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-3 mb-3"
  }, [_c('div', {
    staticClass: "h-8 w-8 bg-blue rounded-full flex items-center justify-center"
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": "/static/roundtable_icons/written_icon.svg"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "text-blueGray-900 font-semibold text-lg font-poppins"
  }, [_vm._v("Written RoundTable")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3.5 flex flex-col"
  }, [_c('h6', {
    staticClass: "text-blueGray-800 font-poppins text-base font-semibold"
  }, [_vm._v("Skills Assessment")]), _vm._v(" "), _c('span', {
    staticClass: "text-blueGray-500"
  }, [_vm._v("\n          Below is a view of the skills you demonstrated in each Written RoundTable, as assessed by your facilitator.\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3.5 flex flex-col"
  }, [_c('h6', {
    staticClass: "text-blueGray-800 font-poppins font-semibold text-base"
  }, [_vm._v("Participation Summary")]), _vm._v(" "), _c('span', {
    staticClass: "text-blueGray-500"
  }, [_vm._v("\n          Below is a view of your participation in each Written RoundTable including the number of original responses, comments and replies.\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-3 mb-3"
  }, [_c('div', {
    staticClass: "h-8 w-8 bg-green-dark rounded-full flex items-center justify-center"
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": "/static/roundtable_icons/verbal_icon.svg"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "text-blueGray-900 font-semibold text-lg font-poppins"
  }, [_vm._v("Verbal RoundTable")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3.5 flex flex-col"
  }, [_c('h6', {
    staticClass: "text-blueGray-800 font-poppins font-semibold text-base"
  }, [_vm._v("Tap In Summary")]), _vm._v(" "), _c('span', {
    staticClass: "text-blueGray-500"
  }, [_vm._v("\n          Below is a view of the discussion skills you demonstrated during your speaking turns in each Verbal RoundTable.\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3.5 flex flex-col space-y-1"
  }, [_c('h6', {
    staticClass: "text-blueGray-800 font-poppins font-semibold text-base"
  }, [_vm._v("Speaking Summary")]), _vm._v(" "), _c('span', {
    staticClass: "text-blueGray-600"
  }, [_vm._v("\n          Below is a view of your time as the speaker in each Verbal RoundTable, compared to the class average.\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col space-y-2"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2.5"
  }, [_c('div', {
    staticClass: "h-8 w-8 bg-orange rounded-full flex items-center justify-center"
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": "/static/roundtable_icons/reflections.svg"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "text-blueGray-900 font-semibold text-lg font-poppins"
  }, [_vm._v("Reflection")])]), _vm._v(" "), _c('div', {
    staticClass: "text-blueGray-600"
  }, [_c('span', [_vm._v("\n          Use the space below to reflect on your progress and contributions so far. Where are you succeeding? What have you learned? What skill would you like to improve on next?\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-596fd987!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/pages/Reports/SummaryTab.vue
// module id = 2281
// module chunks = 61